const LocalStorageKeys = {
    AUTO_FILL_LOGIN_USERNAME: 'autofillLoginUsername',

    CLOVER_TOKEN: 'clover.token',

    DEVICE: 'device',

    GROUP_BOOKING_ASSIGN_GROUP_REFERENCE_SELECTED: 'groupBooking.assignGroupReferenceSelected',

    GROUP_BOOKING_SELECTED: 'groupBooking.selected',

    LAST_ACTIVE_COMPANY_ID: 'lastActiveCompanyID',

    LAST_ITEM_OPTIONS_ERROR_HASH: 'lastItemOptionsErrorHash',

    LOGIN_ERROR_MESSAGE_KEY: 'loginErrorMessageKey',

    LOGIN_SETTINGS: 'loginSettings',

    MELLON_WEBECR_ACCESS_TOKEN: 'mellonWebECR.accessToken',

    ORDER_SEARCH_GROUP_BOOKINGS_ONLY: 'orderSearch.groupBookingsOnly',

    ORDER_SEARCH_INCLUDE_CANCELLED: 'orderSearch.includeCancelled',

    ORDER_SEARCH_INCLUDE_UNCONFIRMED: 'orderSearch.includeUnconfirmed',

    PRINT_TAX_RECEIPTS_SELECTED: 'print-tax-receipts-selected', // TODO: Convert to camelCase

    SELECTED_KITCHEN_ZONES: 'selectedKitchenZones',

    TODAY_VIEW_LAYOUT: 'todayView.layout',
};

module.exports = LocalStorageKeys;
